var _path, _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUs = function SvgUs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    overflow: "hidden",
    viewBox: "360 433 644 488"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "M360 554.458C360 498.424 405.424 453 461.458 453h391.084C908.576 453 954 498.424 954 554.458v235.084C954 845.576 908.576 891 852.542 891H461.458C405.424 891 360 845.576 360 789.542Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#404040",
    fontFamily: "Aptos Mono,Aptos Mono_MSFontService,sans-serif",
    fontSize: 370,
    fontWeight: 400,
    transform: "translate(417.099 802)"
  }, "E")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fill: "#404040",
    fontFamily: "Aptos Mono,Aptos Mono_MSFontService,sans-serif",
    fontSize: 300,
    fontWeight: 400,
    transform: "translate(678.87 802)"
  }, "N")));
};
export default SvgUs;